/** Login do aluno: matrícula + senha, no escopo da escola (RN-18). */
import { useState } from 'react'
import { PasswordInput } from './PasswordInput'
import { PalavrasLogo } from '@/components/PalavrasLogo'
import { isPalavras } from '@/services/palavrasBrand'

import { problemCode } from '@/services/api'
import { login, me } from '@/services/authService'

const MENSAGENS: Record<string, string> = {
  invalid_credentials: 'Matrícula ou senha incorretas.',
  tenant_suspended: 'O acesso desta escola está indisponível no momento.',
  rate_limited: 'Muitas tentativas. Aguarde um instante e tente de novo.',
}

interface LoginViewProps {
  schoolId: string
  tenantSlug: string
  onSuccess: (mustChangePassword: boolean, matricula: string) => void
}

export function LoginView({ schoolId, tenantSlug, onSuccess }: LoginViewProps) {
  const [matricula, setMatricula] = useState('')
  const [password, setPassword] = useState('')
  const [erro, setErro] = useState<string | null>(null)
  const [enviando, setEnviando] = useState(false)

  async function handleSubmit(event: React.FormEvent) {
    event.preventDefault()
    setErro(null)
    setEnviando(true)
    try {
      const tokens = await login({
        matricula,
        password,
        school_id: schoolId,
        tenant_slug: tenantSlug,
      })
      await me()
      onSuccess(tokens.must_change_password, matricula)
    } catch (error) {
      const code = problemCode(error)
      setErro(MENSAGENS[code ?? ''] ?? 'Não foi possível entrar. Tente novamente.')
    } finally {
      setEnviando(false)
    }
  }

  // Sem escola não há login possível (RN-18). Dizer isso é melhor do que
  // deixar o aluno digitar e receber "matrícula ou senha incorretas".
  if (!schoolId) {
    return (
      <div className="login">
        <h1>{isPalavras(tenantSlug) ? 'Palavras Educação' : 'Lúmina'}</h1>
        <p role="alert" className="login-error">
          Para entrar, abra o link de acesso que sua escola ou seu professor enviou.
        </p>
      </div>
    )
  }

  return (
    <div className="auth-layout">
      <aside className="auth-story" aria-label={isPalavras(tenantSlug) ? 'Palavras Educação' : 'Lúmina por Booknando'}>
        <div className="auth-brand">{isPalavras(tenantSlug) ? <PalavrasLogo /> : <>Lúmina<small>por Booknando</small></>}</div>
        <div><p className="auth-story__title">O livro didático, inteiro, em qualquer tela.</p><p className="auth-story__copy">Leia, ouça e pratique. Um novo capítulo começa aqui.</p></div>
        <div className="auth-spines" aria-hidden="true"><span /><span /><span /><span /><span /></div>
      </aside>
    <form className="login" onSubmit={(e) => void handleSubmit(e)}>
      <h1>Entrar</h1>
      <p className="login-help">Acesso do aluno · use a matrícula fornecida pela escola.</p>
      <label htmlFor="matricula">Matrícula</label>
      <input
        id="matricula"
        value={matricula}
        onChange={(e) => setMatricula(e.target.value)}
        autoComplete="username"
        required
      />

      <label htmlFor="senha">Senha</label>
      <PasswordInput
        id="senha"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoComplete="current-password"
        required
      />

      {erro && (
        <p role="alert" className="login-error">
          {erro}
        </p>
      )}

      <button type="submit" disabled={enviando}>
        {enviando ? 'Entrando…' : 'Entrar'}
      </button>

      {/* Sem SMTP na v1: o reset é administrado pelo professor (RN-24). */}
      <p className="login-help">
        Esqueceu a senha? Procure seu professor ou a secretaria da escola.
      </p>
    </form>
    </div>
  )
}
